export default "__VITE_ASSET__DHC19gBE__"